import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=7e04f54f&scoped=true&"
import script from "./ResetPass.vue?vue&type=script&lang=js&"
export * from "./ResetPass.vue?vue&type=script&lang=js&"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=7e04f54f&prod&lang=scss&"
import style1 from "./ResetPass.vue?vue&type=style&index=1&id=7e04f54f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e04f54f",
  null
  
)

export default component.exports